import { render } from "./GlobalModal.vue?vue&type=template&id=ff6ab56c&scoped=true"
import script from "./GlobalModal.vue?vue&type=script&lang=js"
export * from "./GlobalModal.vue?vue&type=script&lang=js"

import "./GlobalModal.vue?vue&type=style&index=0&id=ff6ab56c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff6ab56c"]])

export default __exports__